import React from 'react'

import Typography from 'components/atoms/Typography'
import { func, string } from 'prop-types'
import BackSvg from 'components/atoms/SVGIcons/Back'

const HeaderCustom = ({ title, close }) => (
  <div className="header-custom">
    {close && (
      <div onClick={close} className="header-custom__navigation" data-testid="header-custom-back-btn">
        <BackSvg fill="#0C2846" />
      </div>
    )}
    {title && (
      <Typography variant="subheading" tagName="h2" fontWeight="bold" className="header-custom__title">
        {title}
      </Typography>
    )}
    <style jsx>
      {`
        .header-custom {
          height: 100%;
          padding: 0 16px;

          display: flex;
          align-items: center;
          :global(&__title) {
            color: #1A344F;
            flex-grow: 1;
          }
          &__navigation {
            margin-right: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          @media screen and (min-width: 768px) {
            display: none !important;
          }
        }
      `}
    </style>
  </div>
)

HeaderCustom.propTypes = {
  title: string,
  close: func,
}

export default HeaderCustom
